export enum LandingSymbol {
  T = 'T',
  U_LEFT = 'U_LEFT',
  U_RIGHT = 'U_RIGHT',
  DISABLED = 'DISABLED'
}
